import { render, staticRenderFns } from "./CateTemplate.vue?vue&type=template&id=271e738e&scoped=true&"
import script from "./CateTemplate.vue?vue&type=script&lang=js&"
export * from "./CateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CateTemplate.vue?vue&type=style&index=0&id=271e738e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271e738e",
  null
  
)

export default component.exports